/* eslint-disable @typescript-eslint/no-explicit-any */
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

import { find } from 'es-toolkit/compat';

const { BusinessFeature, Feature } = protos;

export function fetchBusinessFeatures(businessId: number): ApiAction {
  return {
    TockApi: {
      getListProto: `/internal/features/business/${businessId}`,
      type: ClowncarAppConstants.FEATURE_BUSINESS_FETCH,
    },
  };
}

export function fetchFeatures(): ApiAction {
  return {
    TockApi: {
      getListProto: '/internal/feature',
      type: ClowncarAppConstants.FEATURES_FETCH,
    },
  };
}

export function addFeature(feature: any): ApiAction {
  return {
    TockApi: {
      postProto: '/internal/feature',
      type: ClowncarAppConstants.FEATURE_CREATE,
      request: Feature.fromObject(feature),
      toast: 'Feature saved',
    },
  };
}

export function updateFeature(feature: any): ApiAction {
  return {
    TockApi: {
      putProto: '/internal/feature',
      type: ClowncarAppConstants.FEATURE_UPDATE,
      request: Feature.fromObject(feature),
      toast: 'Feature updated',
    },
  };
}

export function toggleToGo(
  businessId: number,
  featuresList: any,
  flagState: 'DISABLED' | 'ENABLED'
): ApiAction {
  const toGoFlagName = 'DELIVERY_TERMS_OF_SERVICE';
  const feature = find(featuresList, (feature) => feature.name === toGoFlagName);
  if (!feature) {
    throw new Error("Couldn't find the DELIVERY_TERMS_OF_SERVICE feature");
  }
  const request = {
    businessId: businessId,
    featureId: feature.id,
    state: flagState === 'ENABLED' ? 'LAUNCHED' : 'UNLAUNCHED',
  };
  return upsertBusinessFeature(request);
}

export function upsertBusinessFeature(feature: any): ApiAction {
  return {
    TockApi: {
      postProto: '/internal/feature/business',
      type: ClowncarAppConstants.FEATURE_BUSINESS_UPDATE,
      request: BusinessFeature.fromObject(feature),
      toast: 'Business feature override updated',
    },
  };
}

export function deleteFeature(featureName: any): ApiAction {
  return {
    TockApi: {
      deleteProto: `/internal/feature/${featureName}`,
      type: ClowncarAppConstants.FEATURE_BUSINESS_UPDATE,
      toast: 'Feature deleted',
    },
  };
}
